const makeQueryFromArray = (parameter, array) => {
    let queryString = new URLSearchParams()
    array.map(item => {
        queryString.append(parameter, item)
    })
    return queryString
}

export default {makeQueryFromArray}
